import React from "react";
import SpeedLossReport from "components/app/report/speedloss/SpeedLossReport";

type ScreenSpeedLossReportProps = React.PropsWithChildren<{}>;

function ScreenSpeedLossReport(props: ScreenSpeedLossReportProps) {
	return <SpeedLossReport />;
}

export default ScreenSpeedLossReport;
